export default __webpack_public_path__ + "static/media/win_three.02820b30.svg";